import Vue from "vue";
import VueI18n from "vue-i18n";
import { maxValue } from "vuelidate/lib/validators";
Vue.use(VueI18n);

const messages = {
	en: {
		DASHBOARD: "Dashboard",
		PATIENT: "Patients",
		LOGIN: "Log In",
		LOGOUT: "Logout",
		LOGINID: "Login ID",
		PASSWORD: "Password",
		KEEPLOGGEDIN: "Keep me logged in",
		FORGETPASSWORD: "Forget password",
		HERE: "here",
		RESETPASSWORD: "Reset Password",
		RESETPASSWORDTEXT: "Please enter your registered email address. Send a new password by email.",
		MAILADDRESS: "Email address",
		PASSWORDFORGOT: "Password forgot",
		MASTER: "Master",
		USERDETAIL: "User Details",
		PRACTITIONERLIST: "Practitioner List",
		PRACTITIONERDETAILS: "Practitioner Details",
		ADD: "Register",
		CANCEL: "Cancel",
		OK: "OK",
		NAME: "Name",
		NAMEKANA: "Name Kana",
		MOBILENUMBER: "Mobile Number",
		ADDRESS: "Address",
		ACCESSAUTHORITY: "Access Authority",
		PRACTITIONERCD: "Practitioner CD",
		SEARCH: "Search",
		VIEWEDITBUSINESS: "View/Edit Business Details",
		VIEWEDITCORPORATEFACILITY: "View/Edit Corporate Facility Details",
		SALESHISTORYREGISTRATION: "Sales History Registration",
		CAREMANAGAERREGISTRATION: "Care Manager Registration",
		BUSINESSREGISTRATION: "Business Registration",
		IMPORT: "Import",
		EXPORT: "Export",
		OFFICELIST: "Office List",
		KEYWORD: "Keyword Search",
		RESET: "Reset",
		SUB_FRANCHISE: "Sub Franchise",
		ACCURACY: "Expected Accuracy",
		LEAFLET_INSTALLATION: "Leaflet Installation",
		SALES_GROUP: "Sales Group",
		NO_OF_VISITS: "Number of Visits",
		ABSENT_PRESENT: "Absent or Present",
		DISTANCE: "Distance",
		SALES_INCHARGE: "Sales Incharge",
		CARE_MANAGER: "Care Manager",
		UPDATED_DATE: "Update Date",
		NUMBER_OF_TRAILS: "Number of Trials",
		BOOK_USAGE: "Book Usage",
		OFFICE_TYPE: "Office Type",
		SCHEDULE_VISIT_DATE: "Scheduled date of visits",
		UNOPENED_LIST: "Unopened List",
		UNMANAGED_LIST: "Unmanaged List",
		UPDATED_DATE_TIME: "Updated date time",
		MAIN_FRANCHISE: "Main Franchise",
		OFFICE_NAME: "Office Name",
		EXPECTED_ACCURACY: "Expected Accuracy",
		ZIP_CODE: "Zip Code",
		PREFECTURE: "Prefectures",
		TELEPHONE_NUMBER: "Telephone Number",
		DISTANCE_HEAD: "Distance",
		DETAILED_SEARCH: "Detailed Search",
		EDIT_USER: "Edit User Information",
		FRANCHISE1: "Franchise A",
		FRANCHISE2: "Franchise B",
		GO_BACK_OFFICE_LIST: "Back to office list",
		REGISTER: "Register",
		EDIT: "Edit",
		SUB_FRANCHISE_REGISTRATION: "Sub franchise registration",
		MAIN_FRANCHISE_REGISTRATION: "Main franchise registration",
		FRANCHISE_NAME: "Franchise name",
		MAIN_FRANCHISE_SHORT_NAME: "Main franchise short name",
		COPORATE_NAME: "Coporate name",
		OWNER_NAME: "Owner name",
		CONTRACT_TYPE: "Contract type",
		MAIN_FRANCHISE_CODE: "Main franchise code",
		STATUS: "Staus",
		SUB_FRANCHISE_NAME: "Sub franchise name",
		OFFICE_ZIP_CODE: "Office zip code",
		ADDRESS_PREFECTURE: "Address Prefecture",
		OFFICE_TELEPHONE_NUMBER1: "Telephone1",
		OFFICE_TELEPHONE_NUMBER2: "Telephone2",
		FAX: "Fax",
		STATE_SIMPLE: "State Simple",
		STATE_DETAILS: "lkState Details",
		ID: "ID",
		CREATED_AT: "Created At",
		CREATED_BY: "Created By",
		UPDATED_AT: "Updated At",
		UPDATED_BY: "Updated By",
		BASENAME: "Sub franchise name",
		SUB_FRANCHISE_INFORMATION: "Sub franchise information",
		SUB_FRANCHISE_SHORT_NAME: "Sub franchise short name",
		BASE_KANA_NAME: "Base kana name",
		BASE_ID: "Base ID",
		MAINFRANCHISELIST: "Main Franchise List",
		IS_MASTER_FLAG: "Is Master Franchise",
		SCREEN: "Screen",
		SCREENLIST: "Screen List",
		SCREENREGISTRATION: "Screen Registration",
		SCREENDETAILS: "Screen Details",
		SCREENNAME: "Name",
		SCREENCODE: "Screen Code",
		REMARKS: "Remarks",
		SIGNUP: "Sign-Up",
		BACK_TO_SCREEN_LIST: "BACK_TO_SCREEN_LIST",
		REGISTER_SCREEN: "Register",
		RENEW: "Renew",
		DOCTOR_DETAILS: "Doctor details",
		DOCTOR_NAME: "Doctor Name",
		DOCTOR_NAME_KANA: "Doctor Name Kana",
		DOCTOR_NAME_KANA_PLC: "Ishimei",
		MOBILEPHONE_NO: "mobile number",
		MEDICAL_INSTITUTE_NAME: "Medical Institution Name",
		MEDICAL_INSTITUTE_NAME_KANA: "Medical institution name Kana",
		ZIPCODE: "zip code",
		CITY: "City/Address",
		STATUS_PLC: "Active",
		CREATION_DATE: "Creation Date",
		AUTHOR: "Author",
		UPDATED_DATETIME: "Updated Date",
		CHANGER: "changed by",
		USER_LIST: "User Lists",
		SURNAME: "Surname",
		LOGIN_ID: "User ID",
		ROLE_NAME: "Role Name",
		EMAIL: "Email",
		USER_CATEGORY: "User Category",
		AUTHORITY_ACCESS_NAME: "Access Authority Name",
		USER_KUBUN: "User Kubun",
		USER_REGISTRATION: "User Registration",
		USER_INFO: "User Information",
		CITY_ADDRESS: "Address",
		FRANCHISE_ADDRESS: "Address",
		BUILDING_NAME: "Building Name",
		NORECORDSFOUND: "No records found",
		AFFILIATION_SETTING: "Affiliation Setting",
		MANAGEMENT_START_DATE: "Start Date",
		MANAGEMENT_END_DATE: "End Date",
		ADD_AFFILIATION: "Add Affiliation",
		DELETE_BUTTON: "Delete",
		ROLE_ACCESS_KEY: "Role name: Access privilege name",
		PRACTITIONER_INFO: "Practitioner Information",
		HAIR_DRESSER_LICENSE_NO: "Hairdresser license registration number",
		ACCUPUNCTURE_LICENSE_N0: "Acupuncture license registration number",
		ANMA_MASSAGE_LICENSE_NO: "Anma Massage Shiatsu Practitioner License Registration Number",
		CREATED_DATE: "Created Date",
		SUCCESS_MESSAGE: "Record created successfully.",
		FAILED_MESSAGE: "Failed to create record.",
		PRACTITIONER_LIST: "Practitioner Master List",
		NUMBER_OF_USERS: "Number of Users",
		PRACTITIONER_REGISTER: "Practitioner Registration",
		PRACTITIONER_ANMA_LICENSE_NO: "Anma Massage Shiatsu Practitioner License Registration Number",
		PRACTITIONER_ACC_LICENSE_NO: "Acupuncture license registration number",
		PRACTITIONER_HAIR_LICENSE_NO: "Hairdresser license registration number",
		JOINED_DATE: "Join Date",
		LEAVING_DATE: "Leaving Date",
		UPDATEFRANCHISE: "Update Franchise",
		SUBFRANCHISELIST: "Sub Franchise List",
		MAIN_FRANCHISE_FLAG_SELECTED_MESSAGE: "This base is already set as main franchise.",
		MEDICAL_QUESTIONARIE: "Medical questionnaire print",
		CARE_MANAGER_NOTIFICATION: "Care manager notification",
		MEDICALINSTITUTE_LIST: "Medical Institution Master",
		MEDICALINSTITUTE_LIST_RETURN: "Return to medical institution master list",
		MEDICALINSTITUTE_NAME: "Medical institution name",
		MEDICALINSTITUTE_NAME_FILL: "Medical institution name",
		MEDICALINSTITUTE_NAME_KANA: "Medical institution name in kana",
		IRYOUKAN: "Iryoukan Meisho",
		CONSENT_FORM_METHOD: "Consent form request method",
		PLEASE_SELECT: "Please select",
		FILL_REMARKS: "Please fill in your notes",
		MEDICINE: "Medicine",
		CANNOT_DELETE: "Cannot delete inactive items.",
		BACK_TO_USER_LIST: "Back to User List",
		BACK_TO_PRACTITIONER_LIST: "Back to Practitioner List",
		CLOSE: "Close",
		Role_Master_Registration: "Role Master Registration",
		Role_Master_List: "Role Master List",
		Role_Master: "Role Master",
		ACCESS_AUTHORITY_ID: "Access Authority Id",
		ACCESS_AUTHORITY_NAME: "Access Authority Name",
		SCREEN_ID: "Screen ID",
		SCREEN_NAME: "Screen SCREEN_NAME",
		CREATE: "Create",
		UPDATE: "Update",
		READ: "Read",
		BACK_TO_ROLE_LIST: "Back to role list",
		ROLE_REGISTRATION_HEADER: "Role Informatoin",
		SCREEN_CODE: "Screen code",
		AUTHORITY_ID: "Authority ID",
		ARE_YOU_SURE_TO_DELETE: "Are you sure you want to delete the selected record?",
		SALES_HISTORY_LIST: "Sales History List",
		CARE_MANAGER_LIST: "Care Manager List",
		TRIAL_USER: "Trial User",
		QUESTIONNARIES: "Questionnaries",
		DOCTOR_MASTER_MENU: "Doctor Master",
		MAIN_FRANCHISE_MASTER_MENU: "Main Franchise Master",
		SUB_FRANCHISE_MASTER_MENU: "Sub Franchise Master",
		PRACTITIONER_MASTER_MENU: "Practitioner Master",
		USER_MASTER_MENU: "User Master",
		SCREEN_MASTER_MENU: "Screen Master",
		ACCESS_AUTHORITY_MASTER_MENU: "Access Authority Master",
		GENERAL_PURPOSE_MASTER_MENU: "General Purpose Master",
		EXTERNAL_SITE_MASTER_MENU: "External Site Master",
		EXTERNAL_SITE_GROUP: "External Sites",
		EXTERNAL_SITE_NO_CREDENTIAL: "No password registered. Please contact your administrator.",
		EXTERNAL_SITE_SITE_NAME: "Site name",
		EXTERNAL_SITE_URL: "URL",
		EXTERNAL_SITE_BASIC_USERNAME: "Basic auth username",
		EXTERNAL_SITE_SORT_ORDER: "Order",
		EXTERNAL_SITE_NOT_REGISTERED: "Not registered",
		EXTERNAL_SITE_CURRENT_PASSWORD: "Current password",
		EXTERNAL_SITE_NEW_PASSWORD: "New password",
		EXTERNAL_SITE_SHOW: "Show",
		EXTERNAL_SITE_HIDE: "Hide",
		EXTERNAL_SITE_PASSWORD_UPDATED_AT: "Password last updated",
		EXTERNAL_SITE_PASSWORD_PLACEHOLDER: "Enter only to change",
		BACK_TO_MAIN_FRANCHISE_LIST: "Back to main franchise list",
		BACK_TO_SUB_FRANCHISE_LIST: "Back to sub franchise list",
		LIST_OF_ACCESS: "List of screen access",
		SCREEN_INFO: "Screen Information",
		TREATMENT_DIVISION: 'Treatment category',
		CUSTOMER_ID: 'User ID',
		CUSTOMER_LASTNAME: 'Customer (last name)',
		CUSTOMER_FIRSTNAME: 'user (first name)',
		CUSTOMER_LASTNAME_KANA: 'furigana',
		CUSTOMER_FIRSTNAME_KANA: 'Furigana (Mei)',
		GENDER: 'gender',
		INSURANCE_CATEGORY: 'Insurance class',
		BURDEN_RATIO: 'Burden Rate',
		DOB: 'date of birth',
		AGE: 'age',
		RELATIONSHIP: 'relationship',
		NURSING_CARE_LEVEL: 'Nursing care level',
		TREATMENT_LOCATION1: 'Treatment location 1 (address on health insurance card, etc.)',
		TREATMENT_LOCATION2: 'Treatment location 2 (address of facility, etc.)',
		TREATMENT_LOCATION3: 'Treatment location 3',
		PROGRESS_MANAGMENT: 'Progress management',
		SCHEDULED_TRIAL_DATE: 'Scheduled trial date',
		HAVE_EXPERIENCE: 'Experience availability',
		HAVE_AUTHORITY: 'authority',
		HAVE_FAMILY: 'Family status',
		CONSENT_FORM_METHOD_DATE: 'Consent Form Request Date',
		CONSENT_DATE: 'Consent date',
		AGREEMENT_STATUS: 'Agreement Status',
		CONSENT_PRINTING: "Consent form print settings",
		QUESTIONNARIE_PDF: "Questionnaire PDF",
		ATTACHMENT_LIST: "Attachment list",
		ATTACHED: "Attached",
		ATTACHED_FILE_NAME: "Attached File",
		COMMENT: "Comment",
		ATTACHEMENT_DATETIME: "Attachment date and time",
		REGISTERED_PERSON: "Registered person",
		HEADQUARTER_COMMENTS: "Headquarters comment",
		HEADQUARTER_REGISTER_DATETIME: "Headquarters registration date and time",
		HEAD_OFFICE_REGISTRANT: "Head office registrant",
		ADDITIONAL_MATERIAL: "Add/change materials",
		IS_SELF: 'authority',
		IS_FAMILY: 'Family status',
		CONSENT_FORM_REQUEST: 'Consent Form Request Date',
		CONSENT_FORM_OBTAIN: 'Consent date',
		FIRST_TREATMENT_DATE: 'First treatment date',
		BUSINESS_HISTORY_LIST: "Business history list",
		DATE_TIME_OCCURRENCE: 'Date and time of history occurrence',
		BRING_YOUR_OWN_TOOLS: 'Bring your own tools',
		BRING_NEXT_TOOLS: 'Next Bring Tool',
		VISIT_DATE: 'Next scheduled visit date',
		OFFICE_INFORMATION: 'Office information',
		BUSINESS_STATUS: 'Status of business establishment',
		LOGOUT_SUCCESS: "You have successfully logged in.",
		LOGIN_SUCCESS: "You have successfully logged out.",
		PLEASEPROVIDE: "You have not entered your{attribute}",
		EMAIL_VALIDATION: "{attribute} is not a valid email.",
		INVALID_POSTAL_CODE: "Please enter the correct zip code.",
		CHARACTER_RANGE_BETWEEN: "Please enter {attribute} between {min} and {max}.",
		DIGIT_RANGE_BETWEEN: "Please enter {attribute} between {min} and {max} digits.",
		BETWEEN_EIGHT_THIRTY: "Please enter {attribute} between 8 and 30.",
		GROUP_NAME: "Group Name",
		ORDER_NARABI: "Order",
		HANYO_NAME: "Hanyo Name",
		HANYO_VALUE: "Hanyo value",
		HANYO_MASTER: "Hanyo master",
		ADD_HANYO: "Add Hanyo",
		MAIN_FRANCHISE_INFO: "Main Franchise Information",
		PLEASE_FILL_REQUIRED_FIELDS: "Please fill the required field.",
		SELECT_TYPE: "Select Type",
		CONFIRM_EXPORT: "No data is selected. Do you want to export all data?",
		YES_EXPORT: "Ok",
		YES_EXPORT_ALL: "Export all results",
		NO_CANCEL: "Cancel",
		SUCCESSFULLY_IMPORTED: "All data has been successfully imported.",
		UPLOAD: "Upload",
		UPLOAD_FILE: "Upload File",
		PLEASE_UPLOAD_CSV: "Please upload Csv file to import data",
		CHOOSE_FILE: "Choose a file or drop it here...",
		DROP_FILE: "Drop file here...",
		PICK_DATE: "Pick a date",
		MASTER_FLAG: "Set this subfranchise as a main franchise core store",
		HEADQUARTER_COMMENT_DATETIME: "Headquarter comment date time",
		ATTACHMENT_SUBMIT: "Reflected in attachments",
		UPLOAD_FILE_LIMIT: "You can upload up to 2 files.",
		PRINT: "Print",
		OUTPUT_CONSENT_FORM: "Output consent form",
		OUTPUT_CONDITION: "Output Conditions",
		PRINT_PREVIEW: "Print Preview",
		BUSINESS_HISTORY_STATUS: "Business History Status",
		COMBIENEDNAMELENTGH: "Please enter first name and last name in 1 to 20",
		COMBIENEDKANANAMELENTGH: "Please enter first kana name and last kana name in 1 to 20",
		CONTACTIMPORT: "Contact Import",
		CUSTOMERIMPORT: "Customer Import",
		PLEASEIMPORTORDER: "Please import in the following order.",


		BUSINESS_DESTINATION_LIST: "Business Destination List",
		BUSINESS_DESTINATION_REGISTRATION: "Business Destination Registration",
		BUSINESS_DESTINATION_DETAILS: "Business Destination Details",
		BACK_TO_BUSINESS_DESTINATION_LIST: "Back to business destination list",
		DB_ID: "ID",
		VISIT_COUNT: "Visit Count",
		TRIAL_COUNT: "Trial Count",
		USERS_COUNT: "Users Count",
		CARE_MANAGERS_COUNT: "Care Managers Count",
		BUSINESS_ADDRESS_REMARKS: "Business address remarks",
		ATTACHMENTS: "Attachments",
		OPENING_DATE: "Opening date",
		CARE_INSURANCE_OFFICE_NUMBER: "Care insurance office number",
		BUSINESS_DESTINATION_CODE: "ID",
		START_DATE: "Start Date",
		END_DATE: "End Date",
		AHAKI_NUMBER: "Ahaki number has not been entered.",
		HEADQUARTER_USER_DELETE_MESSAGE: "You cannot delete headquarter user.",
		CREATED_DATE_BUSINESS_HISTORY: "Created Date",
		ABOUT_KEYWORD: "About keyword search",
		KEYWORD_SEARCH_TARGET: "	Keyword Search Target",
		PLEASE_UPLOAD_FILE: "Please upload this file",
		PRINT_CONTENT: "Print Content",
		OUTPUT_CONTENT: "Output Content",
		MORE_THAN_FILE: "You can upload up to {files} attachment.",
		FILE_SIZE_VALIDATION: "Attachments (images) must be less than 10MB.",
		PASSWORDLENGTH: "Please enter {attribute} between 8 and 30. characters",
		ROLE_DELETE: "Multiple access privilege masters cannot be deleted at the same time. Please select only one record and execute the deletion process.",
		SEND: "Send",
		YES: "Yes",
		EMAILEMPTYERROR: "The email address is not registered in the care manager information. Please register your email address and try again.",
		FILEUPLOADFAILED: "Unable to upload file",
		LOGINID_REGEX: "Please enter {attribute} in half-width alphanumeric characters.",
		PRACTITIONER_UPDATE_MSG: 'The current user is a practitioner. If you wish to update, please update on the practitioner registration screen.',
		DUPLICATE_SUB_FRANCHISE: 'The same location is selected. please confirm.',
		PRACTITIONER_LIST_USER_DELETE: "The current user is a practitioner. If you want to delete it, please delete it from the practitioner master list.",
		HOMELOGINMESSAGE: "Please select a location to log in",
		ADDRESSANDBUILDINGNAME: "Please enter the prefecture + address + building name in 1 to 65 characters.",
		LOGIN_TIMEOUT: "Session timed out. Please log in again.",
		FILE_COMPRESSED_ERROR: "The attached file exceeds 3M even after automatic compression processing. Please check the file size.",
		MULTIPLE_KEYWORD_NOT_ALLOWED: "Multiple keywords cannot be searched",
		USER: "User",
		PERSON_INCHARGE: "Person Incharge",
		AHAKI_NUMBER_ERROR: "Only half-width numbers and hyphens can be entered for the ahaki number.",
		REMOVE_ATTACHMENT: "Images can be deleted by Reflecting on attachments and will be deleted when updated.",
		ATTACHMENT_FILE_FORMAT_ERROR: "You cannot attach anything other than Jpeg, Png, or PDF.",
		OTHER_FILE_FORMAT_ERROR: "You cannot attach anything other than Jpeg or Png.",
		PDF_SIZE_ERROR: "Attachments (PDF) must be less than or equal to 5MB.",
		ATTACHMENT_MESSAGE: "Images (Jpeg, Png) up to 10Mb, PDF up to 5Mb",
		MEDICALINSTADDRESSLENTGH: "Prefeature, Address and Building name should be in 57 lentgh",
		REMOVE_OTHER_ATTACHMENT: "Image will be deleted after pressing {type} button.",
		INSTITUTE_CODE: "Institute code",
		ADDRESSOVERWRITE: "An address has already been entered. Do you want to overwrite it with the postal code address you obtained?",
		YES: "Yes",
		NO: "No",
		CONFIRMATION: "Confirmation",
		HOJIN_INFORMATION: "Hojin Information",
		HOJIN_REGISTRATION: "Hojin Registration",
		HOJIN_LIST: "Hojin List",
		COMMON_CANNOT_CHANGE: "common cannot be changed",
		PLEASE_UNSELECT_FLAG: "Before assigning to another flagship store, uncheck Set this location as flagship store",
		SETTING: "Setting",
		PERSON_INCHARGE_SETTING: "Person Incharge Setting",
		PERSON_INCHARGE_ERROR: "No users selected.",
		FAVOURITE_SETTING: "Favorite settings",
		SHOW_FAVOURITE_ONLY: "Show favorites only",
		SET_FAVOURITE: "Set favorite",
		CONFIRM_USER_REG_MANAGER: "Is it okay to actually register instead of sending it to the headquarters?",
		FAVOURITE_DATA_ERROR: "Select add or delete from favorite settings.",
		SHOW_INACTIVE_BASE_ALSO: "Also show inactive locations",
		KANA_ONLY: "Enter Only KataKana Input for {attibute}",
		TRAVEL_COMPANION: "Travel companion",
		FACILITY_RESPONSE_PERSON: "Facility response person",
		KEY_PERSON: "Key person",
		LETTER_ENCLOSED: "Letter enclosed",
		THANK_YOU_EMAIL: "Thank you email",
		THANK_YOU_PHONE: "Thank you phone call",
		COMMENT_REPORT: "Comment -> Response report",
		ONLY_CORPORATE: "Show only corporate projects",
		ONLY_OFFICE: "Show only general projects",
		TRIAL_REQUEST_NOTIFICATION: "Trial request notification",
		HOJIN: "Corporate",
		CORPORATE_SEARCH: "Corporate facility search",
		OFFICE_SEARCH: "General facility search",
		CONTACT_INFORMATION: "Contact Information",
		REQUESTED_DATE: "Requested Date",
		FAMILY_CONFIRMATION: "Family Confirmation Form",
		JOKYO: "Status",
		VENUE_ALLOCATION_DATE: "Venue Allocation Date",
		MAIL_RECEIPT: "Mail Receipt",
		PROXY: "Proxy",
		CAREMAN_SEARCH: "Careman Search",
		ADD_MORE_CONTACT: "Add Contact Information",
		CANCLE_TO_CORPORATE_CASE: "Is it okay to cancel the corporate case",
		//for hojin 注釈隣 HW-2
		CORPORATECHUITITLE: "About list details",
		UPDATEDATEDESCENDING: "Update Date Descending",
		CONTRACTTYPELATESTSHOW: "Contract Type: Shows the latest contract type",
		OUTSOURCINGFEE: "Corporate business outsourcing fees and administrative fees: Tax included",
		EXPORT_FILTERED: "Export Filtered Data",
		ONLY_EMPTY: "Search only empty data",
	},
	ja: {
		maxValueMsg: '{attribute}は 100% より大きくできません。',
		DASHBOARD: "ダッシュボード",
		PATIENT: "忍耐強い",
		LOGIN: "ログイン",
		LOGOUT: "ログアウト",
		LOGINID: "ログインID",
		PASSWORD: "パスワード",
		KEEPLOGGEDIN: "ログイン情報を記録する",
		FORGETPASSWORD: "パスワードを忘れた場合は",
		HERE: "こちら",
		RESETPASSWORD: "パスワードの再発行",
		RESETPASSWORDTEXT: "登録されているメールアドレスを入力してください。 新しいパスワードをメールで送信します。",
		MAILADDRESS: "メールアドレス",
		PASSWORDFORGOT: "パスワード再発行",
		MASTER: "マスタ管理",
		USERDETAIL: "ユーザーの詳細",
		PRACTITIONERDETAILS: "プラクティショナーの詳細",
		PRACTITIONERLIST: "施術者リスト",
		ADD: "登録",
		UPDATE: "更新",
		CANCEL: "キャンセル",
		OK: "OK",
		NAME: "氏名",
		NAMEKANA: "氏名カナ",
		MOBILENUMBER: "携帯番号",
		ADDRESS: "住所",
		ACCESSAUTHORITY: "アクセス権限名",
		PRACTITIONERCD: "施術家 CD",
		SEARCH: "検索",
		VIEWEDITBUSINESS: "事業所詳細を表示・編集",
		VIEWEDITCORPORATEFACILITY: "法人施設詳細を表示・編集",
		RESPONSIBLEBASEREGISTRATION: "担当拠点登録",
		SALESHISTORYREGISTRATION: "営業履歴登録",
		CAREMANAGAERREGISTRATION: "施設職員登録",
		BUSINESSREGISTRATION: "事業所登録",
		IMPORT: "インポート",
		EXPORT: "エクスポート",
		OFFICELIST: "事業所リスト",
		KEYWORD: "キーワード検索",
		RESET: "リセット",
		SUB_FRANCHISE: "拠点",
		ACCURACY: "見込み確度",
		LEAFLET_INSTALLATION: "チラシ設置",
		SALES_GROUP: "営業グループ",
		NO_OF_VISITS: "訪問回数",
		ABSENT_PRESENT: "不在を除く",
		DISTANCE: "距離(Km)",
		DISTANCE_KM: "往療距離(km)",
		SALES_INCHARGE: "担当営業",
		CARE_MANAGER: "施設職員在籍数",
		UPDATED_DATE: "更新日",
		NUMBER_OF_TRAILS: "お試し数",
		BOOK_USAGE: "本利用数",
		OFFICE_TYPE: "事業所種別",
		SCHEDULE_VISIT_DATE: "訪問予定日",
		UNOPENED_LIST: "未営業リストも表示",
		UNMANAGED_LIST: "管理対象外も表示",
		UPDATED_DATE_TIME: "更新日時",
		MAIN_FRANCHISE: "基幹店名",
		OFFICE_NAME: "事業所名",
		OFFICE: "事業所",
		EXPECTED_ACCURACY: "見込確度",
		ZIP_CODE: "郵便番号",
		PREFECTURE: "都道府県",
		TELEPHONE_NUMBER: "電話番号",
		DISTANCE_HEAD: "距離",
		DETAILED_SEARCH: "詳細検索",
		EDIT_USER: "ユーザー情報編集",
		FRANCHISE1: "基幹店名A",
		FRANCHISE2: "基幹店名B",
		GO_BACK_OFFICE_LIST: "事業所リストへ戻る",
		REGISTER: "登録",
		EDIT: "更新",
		SUB_FRANCHISE_REGISTRATION: "拠点登録",
		FRANCHISE_NAME: "基幹店名",
		MAIN_FRANCHISE_SHORT_NAME: "基幹店名略称",
		COPORATE_NAME: "法人名",
		OWNER_NAME: "オーナー名",
		CONTRACT_TYPE: "契約種別",
		MAIN_FRANCHISE_CODE: "基幹店ID",
		STATUS: "ステータス",
		SUB_FRANCHISE_NAME: "拠点名",
		OFFICE_ZIP_CODE: "郵便番号",
		ADDRESS_PREFECTURE: "住所",
		OFFICE_TELEPHONE_NUMBER1: "電話番号①",
		OFFICE_TELEPHONE_NUMBER2: "電話番号②",
		FAX: "FAX番号",
		SUB_FAX: "FAX",
		STATE_SIMPLE: "状態(簡易)",
		STATE_DETAILS: "状態(詳細)",
		ID: "ID",
		CREATED_AT: "作成日時",
		CREATED_BY: "作成者",
		UPDATED_AT: "更新日時",
		UPDATED_BY: "更新者",
		BASENAME: "拠点名",
		SUB_FRANCHISE_INFORMATION: "拠点情報",
		SUB_FRANCHISE_SHORT_NAME: "拠点名略称",
		BASE_KANA_NAME: "拠点名カナ",
		BASE_ID: "拠点ID",
		SUB_ID: "ID",
		CITY_ADDRESS: "市区町村・番地",
		FRANCHISE_ADDRESS: "住所（市区町村・番地）",
		BUILDING_NAME: "建物名",
		EMAIL: "メール",
		RECEIPT_CHARGE: "レセプト担当",
		RECEIPT_START_DATE: "レセプト拠点対応開始日",
		USER_REGISTRATION_MANAGER: "利用者登録担当",
		USER_REGISTRATION_START_DATE: "利用者登録拠点対応開始日",
		CONTRACT_DATE: "契約日",
		CANCELLATION_DATE: "解約申出日",
		CONTRACT_END_DATE: "契約終了日",
		PLUS_CONTRACT_DATE: "プラス契約日",
		PLUS_CONTRACT_END_DATE: "プラス契約終了日",
		PLUS_MEMBER: "プラス加盟店",
		PLUS_MEMBER_ONLY: "プラス加盟店のみ",
		LAST_TREATMENT_MONTH: "最終施術月",
		OFFICE_REMARKS: "事務備考",
		MAINFRANCHISELIST: "基幹店一覧",
		IS_MASTER_FLAG: "基幹店Flag",
		SCREEN: "画面",
		SCREENLIST: "画面一覧",
		SCREENREGISTRATION: "画面登録",
		SCREENDETAILS: "画面詳細",
		SCREENNAME: "画面名",
		SCREENCODE: "場面 ID",
		REMARKS: "備考",
		SIGNUP: "新規登録",
		BACK_TO_SCREEN_LIST: "画面リストに戻る",
		REGISTER_SCREEN: "登録",
		RENEW: "更新",
		DOCTOR_DETAILS: "医師詳細",
		DOCTOR_NAME: "医師名",
		DOCTOR_NAME_KANA: "医師名カナ",
		DOCTOR_NAME_KANA_PLC: "イシメイ",
		MOBILEPHONE_NO: "携帯番号",
		MEDICAL_INSTITUTE: "医療機関",
		MEDICAL_INSTITUTE_NAME: "医療機関名",
		MEDICAL_INSTITUTE_NAME_KANA: "医療機関名カナ",
		CITY: "市区町村・番地",
		STATUS_PLC: "アクティブ",
		CREATION_DATE: "作成日時",
		AUTHOR: "作成者",
		UPDATED_DATETIME: "更新日時",
		CHANGER: "更新者",
		DOCTOR_MASTER_LIST: "医師マスタ一覧",
		DOCTOR_MASTER_LIST_MENU: "医師マスタ",
		DOCTOR_REGISTRATION: "医師登録",
		REGISTRATION: "登録",
		UPDATION: "更新",
		CREATE: "Create",
		DELETE: "Delete",
		READ: "Read",
		SCREEN_ID: "画面ID",
		SCREEN_NAME: "画面名",
		BACK_TO_ROLE_LIST: "画面アクセス権限一覧へ戻る",
		ROLE_REGISTRATION_HEADER: "ロール情報",
		SCREEN_CODE: "画面CD",
		LIST_OF_ACCESS: "画面アクセス権限一覧",
		SCREEN_INFO: "画面情報",
		BUSINESS_DESTINATION_LIST: "出張先一覧",
		BUSINESS_DESTINATION_REGISTRATION: "事業所登録",
		BUSINESS_DESTINATION_DETAILS: "事業所詳細",
		BACK_TO_BUSINESS_DESTINATION_LIST: "ビジネス目的地リストに戻る",
		DB_ID: "dbID",
		VISIT_COUNT: "訪問回数(回)",
		TRIAL_COUNT: "お試し数(人)",
		USES_COUNT: "本利用数(人)",
		CARE_MANAGERS_COUNT: "施設職員在籍数(人)",
		BUSINESS_ADDRESS_REMARKS: "事業所備考",
		ATTACHMENTS: "添付ファイル ※3ファイルアップロードできます",
		OPENING_DATE: "開業年月日",
		CARE_INSURANCE_OFFICE_NUMBER: "介護保険事業所番号",
		BUSINESS_DESTINATION_CODE: "ID",

		BUSINESS_HISTORY_LIST: "営業履歴一覧",
		DATE_TIME_OCCURRENCE: '履歴発生日時',
		OFFICE_INFORMATION: '事業所情報',
		BUSINESS_STATUS: '事業所のステータス',
		GROUP_NAME: "グループ名",
		ORDER_NARABI: "並び替え",
		HANYO_NAME: "名前",
		HANYO_VALUE: "値",
		HANYO_MASTER: "汎用マスタ",
		ADD_HANYO: "選択肢の追加",
		MAIN_FRANCHISE_INFO: "基幹店情報",
		PLEASE_FILL_REQUIRED_FIELDS: "必須フィールドに入力してください。",
		SELECT_TYPE: "タイプの選択",
		CONFIRM_EXPORT: "データが選択されていません。すべてのデータをエクスポートしますか？",
		YES_EXPORT: "OK",
		YES_EXPORT_ALL: "全件をエクスポート",
		NO_CANCEL: "キャンセル",
		SUCCESSFULLY_IMPORTED: "すべてのデータが正常にインポートされました。",
		UPLOAD: "アップロード",
		UPLOAD_FILE: "ファイルをアップロードする",
		PLEASE_UPLOAD_CSV: "データをインポートするにはcsvファイルをアップロードしてください。",
		CHOOSE_FILE: "ファイルを選択するか、ここにドロップします...",
		DROP_FILE: "ここにファイルをドロップ...",
		MASTER_FLAG: "この拠点を基幹店に設定",
		MAIN_FRANCHISE_REGISTRATION: "基幹店登録",
		CREATED_DATE_BUSINESS_HISTORY: "履歴発生日時",
		CARE_MANAGER_FURIGANA: "フリガナ",
		GO_BACK_TO_PREVIOUS_PAGE: "前のページに戻る",
		DONOT_DELETE_OFFICE: 'この事業所はすでに利用者情報と施設職員に設定されデータがあります。利用者情報および施設職員の情報を別の事業所に変更してから削除してください。',
		//validation messages
		REQUIREDFIELD: "{attribute}が入力されていません。",
		SELECTREQUIRED: "{attribute}が選択されていません。",
		NUMBERREQUIRED: "{attribute}が入力されていません。",
		DECIMAL: "半角数字を入力してください(小数が含まれている場合は、小数点以下第4位までの桁数に制限してください)。",
		NUMERIC: "半角数字を入力してください。",
		PLEASEPROVIDE: "{attribute}が入力されていません。",
		EMAIL_VALIDATION: "{attribute}は有効なメールではありません。",
		NUMBERDECIMAL: "半角数字を入力してください。(小数点以下の値を含む場合は、小数点第二位までの値で入力してください)",
		NUMBERWITHOUTDECIMAL: "半角数字を入力してください。",
		DECIMALONLYONE: "半角数字を入力してください。(小数点以下の値を含む場合は、小数点第一位までの値で入力してください)",
		KANAERORMSG: "登録しているデータが正しくありません。",
		VALIDPASSWORD: "パスワードは少なくとも8文字でなければなりません。",
		BETWEENRANGE: "範囲内の数字を入力してください。",
		MINLENGTH: "最小値は3でなければなりません。",
		DIGITMAXLENGTH: "{attribute}は{min}桁から{max}桁の間で入力してください。",
		MAXLENGTH: "{attribute}は{min}文字から{max}文字の間で入力してください。",
		RANGENOTE: "文字を入力してください。",
		FIRSTHALF: "少なくとも",
		SECONDHALF: "文字でなければなりません。",
		MACHINEDEPENDENTCHARACTERS: "機種依存文字は入力できません。",
		USER_LIST: "ユーザー一覧",
		SURNAME: "苗字",
		LOGIN_ID: "ユーザーID",
		ROLE_NAME: "ロール名",
		USER_CATEGORY: "ユーザー区分",
		AUTHORITY_ACCESS_NAME: "アクセス名",
		USER_KUBUN: "あはき番号",
		USER_REGISTRATION: "ユーザー登録",
		USER_INFO: "ユーザー情報",
		NORECORDSFOUND: "レコードが見つかりません。",
		AFFILIATION_SETTING: "所属拠点設定",
		MANAGEMENT_START_DATE: "管理開始日",
		MANAGEMENT_END_DATE: "管理終了日",
		ADD_AFFILIATION: "所属拠点を追加",
		DELETE_BUTTON: "削除",
		ROLE_ACCESS_KEY: "ロール名：アクセス権限名",
		PRACTITIONER_INFO: "施術家情報",
		HAIR_DRESSER_LICENSE_NO: "きゅう免許登録番号",
		ACCUPUNCTURE_LICENSE_N0: "はり免許番号",
		ANMA_MASSAGE_LICENSE_NO: "あん摩マッサージ指圧免許登録番号",
		CREATED_DATE: "作成日",
		SUCCESS_MESSAGE: "レコードが正常に作成されました。",
		FAILED_MESSAGE: "レコードの作成に失敗しました。",
		PRACTITIONER_LIST: "施術家マスタ一覧",
		NUMBER_OF_USERS: "ユーザー数",
		PRACTITIONER_REGISTER: "施術家登録",
		PRACTITIONER_ANMA_LICENSE_NO: "あん摩マッサージ指圧師免許登録番号",
		PRACTITIONER_ACC_LICENSE_NO: "はり師免許登録番号",
		PRACTITIONER_HAIR_LICENSE_NO: "きゅう師免許登録番号",
		JOINED_DATE: "入社日",
		LEAVING_DATE: "退職日",
		ALLOWENGLISHANDHALFWIDTHONLY: "{attribute}は半角で入力してください。",
		HYPHENNOTENTERED: "電話番号はハイフン入りで入力してください",
		HYPHENPLACEDINCORRECT: "{attribute}ハイフンの位置が正しくありません。",
		MAXTWOHYPHENALLOW: "{attribute}には最大二つハイフンを 使用してください。",

		UPDATEFRANCHISE: "拠点一覧",
		SUBFRANCHISELIST: "拠点一覧",
		MAIN_FRANCHISE_FLAG_SELECTED_MESSAGE: "他の拠点は既に基幹店に設定済み",
		MEDICAL_QUESTIONARIE: "問診票印刷",
		CARE_MANAGER_NOTIFICATION: "施設職員通知",
		MEDICALINSTITUTE_DETAILS: "医療機関詳細",
		MEDICALINSTITUTE_LIST: "医療機関マスタ一覧",
		MEDICALINSTITUTE_LIST_MENU: "医療機関マスタ",
		MEDICALINSTITUTE_LIST_RETURN: "医療機関マスタ一覧へ戻る",
		MEDICALINSTITUTE_REGISTRATION: "医療機関登録",
		DOCTOR_LIST_RETURN: "医師マスタ一覧へ戻る",
		MEDICALINSTITUTE_NAME: "医療機関名",
		MEDICALINSTITUTE_NAME_FILL: "医療機関名称",
		MEDICALINSTITUTE_NAME_KANA: "医療機関名カナ",
		IRYOUKAN: "イリョウキカンメイショウ",
		CONSENT_FORM_METHOD: "同意書依頼方法",
		PLEASE_SELECT: "選択してください",
		SELECT: "選択",
		FILL_REMARKS: "備考を記入してください",
		MEDICINE: "所属する医師",
		CARE_MANAGER_LIST_RETURN: "施設職員一覧へ戻る",
		CARE_MANAGER_INFO: "施設職員情報",
		CARE_MANAGER_NAME: "施設職員氏名",
		CARE_MANAGER_NAME_KANA: "施設職員氏名カナ",
		CAREMAN_INCHARGE_COUNT: "担当数",
		TITLE: "肩書",
		// ATTACHED_FILE: "添付ファイル ※2ファイルアップロードできます",
		// ATTACHED_3_FILE: "添付ファイル ※3ファイルアップロードできます",
		ATTACHED_FILE: "画像（Jpeg,Png)は10Mb以下で2ファイル迄",
		ATTACHED_3_FILE: "画像（Jpeg,Png)は10Mb以下で3ファイル迄",
		DRAG_FILES_HERE: "ここにファイルをドラッグするかクリックしてアップロードしてください",
		SALES_HISTORY: "営業履歴",
		DATE_TIME: "日時",
		METHOD: "方法",
		POTENTIAL: "見込み",
		ASSIGNMENT: "担当",
		BRING_YOUR_OWN_TOOLS: "持参ツール",
		CONTENT: "内容",
		CARE_MANAGMENT: "施設職員",
		NEXT_VISIT: "次回訪問予定日",
		TOOLS_BRING_NEXT_TIME: "次回持参ツール",
		ABBRIVIATION: "拠点略称",
		MAIN_FC_ABBRIVIATION: "基幹店略称",
		CAREMAN_LIST: "施設職員マスタ一覧",
		CAREMAN_REGISTRATION: "施設職員登録",
		DISPLAY_AFTER_MANAGEMENT: "管理終了の施設職員も表示",
		ATTACHMENT: "添付ファイル",

		CANNOT_DELETE: "非アクティブなアイテムは削除できません。",
		BACK_TO_USER_LIST: "ユーザー一覧へ戻る",
		BACK_TO_PRACTITIONER_LIST: "施術家マスタ一覧へ戻る",
		CLOSE: "閉じる",
		Role_Master_Registration: "画面アクセス権限マスタ登録",
		Role_Master_List: "画面アクセス権限マスタ一覧",
		Role_Master: "画面アクセス権限マスタ",
		ACCESS_AUTHORITY_ID: "アクセス権限ID",
		ACCESS_AUTHORITY_NAME: "アクセス権限名",
		AUTHORITY_ID: "権限ID",
		ARE_YOU_SURE_TO_DELETE: "選択したレコードを削除してよろしいですか?",
		YES_DELETE: "はい",
		CANCEL_DELETE: "キャンセル",
		SALES_HISTORY_LIST: "営業履歴一覧",
		CARE_MANAGER_LIST: "施設職員一覧",
		TRIAL_USER: "お試し利用者",
		QUESTIONNARIES: "問診票",
		DOCTOR_MASTER_MENU: "医師マスタ",
		SUB_FRANCHISE_MASTER_MENU: "拠点マスタ",
		MAIN_FRANCHISE_MASTER_MENU: "基幹店マスタ",
		PRACTITIONER_MASTER_MENU: "施術家マスタ",
		USER_MASTER_MENU: "ユーザーマスタ",
		SCREEN_MASTER_MENU: "画面マスタ",
		ACCESS_AUTHORITY_MASTER_MENU: "アクセス権限マスタ",
		GENERAL_PURPOSE_MASTER_MENU: "汎用マスタ",
		EXTERNAL_SITE_MASTER_MENU: "外部サイトマスタ",
		EXTERNAL_SITE_GROUP: "外部サイト",
		EXTERNAL_SITE_NO_CREDENTIAL: "パスワードが未登録です。管理者にお問い合わせください。",
		EXTERNAL_SITE_SITE_NAME: "サイト名",
		EXTERNAL_SITE_URL: "URL",
		EXTERNAL_SITE_BASIC_USERNAME: "Basic認証ユーザー名",
		EXTERNAL_SITE_SORT_ORDER: "並び順",
		EXTERNAL_SITE_NOT_REGISTERED: "未登録",
		EXTERNAL_SITE_CURRENT_PASSWORD: "現在のパスワード",
		EXTERNAL_SITE_NEW_PASSWORD: "新しいパスワード",
		EXTERNAL_SITE_SHOW: "表示",
		EXTERNAL_SITE_HIDE: "隠す",
		EXTERNAL_SITE_PASSWORD_UPDATED_AT: "パスワード最終更新",
		EXTERNAL_SITE_PASSWORD_PLACEHOLDER: "変更する場合のみ入力",
		PHONEREGEX: "{attribute}は半角数値とハイフンのみ入力できます。",
		ZIPREGEX: "{attribute}の形式が正しくありません。(XXX-XXXX)",
		NODOCTORSCURRENTLY: "所属する医師は現在いません。",
		BACK_TO_MAIN_FRANCHISE_LIST: "基幹店一覧へ戻る",
		BACK_TO_SUB_FRANCHISE_LIST: "拠点一覧へ戻る",
		FACILITYCODEREGEX: "{attribute}は6桁の数字のみ入力してください。",

		//CUTOMER
		CUSTOMER_RETURN: '利用者一覧へ戻る',
		CUSTOMER_INFO: '利用者情報',
		TREATMENT_DIVISION: '施術区分',
		CUSTOMER_ID: '利用者ID',
		CUSTOMER_LASTNAME: '利用者(姓)',
		CUSTOMER_FIRSTNAME: '利用者(名)',
		CUSTOMER_LASTNAME_KANA: 'フリガナ(セイ)',
		CUSTOMER_FIRSTNAME_KANA: 'フリガナ(メイ)',
		GENDER: '性別',
		INSURANCE_CATEGORY: '保険区分',
		BURDEN_RATIO: '負担割合',
		DOB: '生年月日',
		AGE: '年齢',
		RELATIONSHIP: '続柄',
		NURSING_CARE_LEVEL: '要介護度',
		TREATMENT_LOCATION1: '施術場所1(保険証等の住所)',
		TREATMENT_LOCATION2: '施術場所2(施設等の住所)',
		TREATMENT_LOCATION3: '施術場所3',
		PROGRESS_MANAGMENT: '進捗管理',
		FAMILY_GATHERING_DATE: '家族会参加日',
		TRIAL_SESSION_PARTICIPATION_DATE: '体験会参加日',
		SCHEDULED_TRIAL_DATE: 'お試し予定日',
		HAVE_EXPERIENCE: '体験実施可否',
		HAVE_AUTHORITY: '本人可否',
		CONSENT_FORM_METHOD_DATE: '同意書依頼日',
		CONSENT_DATE: '同意書取得日',
		AGREEMENT_STATUS: '同意書状況',
		CONSENT_PRINTING: "同意書印刷設定",
		QUESTIONNARIE_PDF: "問診票PDF",
		ATTACHMENT_LIST: "添付資料一覧",
		ATTACHED: "添付",
		ATTACHED_FILE_NAME: "添付資料",
		COMMENT: "コメント",
		ATTACHEMENT_DATETIME: "添付日時",
		REGISTERED_PERSON: "登録者",
		HEADQUARTER_COMMENTS: "本部コメント",
		HEADQUARTER_REGISTER_DATETIME: "本部登録日時",
		HEAD_OFFICE_REGISTRANT: "本部登録者",
		ADDITIONAL_MATERIAL: "資料追加/変更	",
		REGISTRATION_HISTORY: "登録履歴",
		HISTORY_NO: "履歴No.",
		REGISTRATION_DIVISION: "登録区分",
		REJECTION_REASON: "差戻し理由・確認事項",
		IS_SELF: '本人可否',
		IS_FAMILY: '家族可否',
		CONSENT_FORM_REQUEST: '同意書依頼日',
		CONSENT_FORM_OBTAIN: '同意書取得日',
		FIRST_TREATMENT_DATE: '初療日',
		HEADQUARTER_COMMENT_DATETIME: "本部コメント日時",
		ATTACHMENT_SUBMIT: "添付資料に反映",
		UPLOAD_FILE_LIMIT: "最大 2 ファイルまでアップロードできます。",
		CUSTOMER_REGISTRATION: 'お試し新規登録',
		CUSTOMER_LIST: '利用者一覧',
		REGISTER_DATETIME: '登録日時',
		CUSTOMER_FULL_NAME: '利用者(姓名)',
		CUSTOMER_FULL_NAME_KANA: '利用者(カナ)',
		PRACTITIONER_INCHARGE: '担当施術家',
		COMBIENEDNAMELENTGH: "利用者(姓と名)は1文字から20文字の間で入力してください。",
		COMBIENEDKANANAMELENTGH: "フリガナ(セイとメイ)は1文字から20文字の間で入力してください。",
		CONTACTIMPORT: "連絡先インポート",
		CUSTOMERIMPORT: "利用者インポート",

		LOGOUT_SUCCESS: "ログアウトに成功しました。",
		LOGIN_SUCCESS: "ログインに成功しました。",
		CHARACTER_RANGE_BETWEEN: "{attribute}は{min}文字から{max}文字の間で入力してください。",
		DIGIT_RANGE_BETWEEN: "{attribute}は{min}から{max}桁の間で入力してください。",
		BETWEEN_EIGHT_THIRTY: "{attribute}は5文字から30文字の間で入力してください。",
		PLEASESELECT: "同意書依頼方法",
		INVALID_POSTAL_CODE: "正しい郵便番号を入力してください。",
		INVALID_POSTAL_CODE1: "この郵便番号は自動変換出来ません。手動で入力してください。",
		PICK_DATE: "日付を選択します",
		DELETE_SUCCESS: "正常に削除されました。",
		PRINT: "印刷",
		OUTPUT_CONSENT_FORM: "出力同意書様式",
		OUTPUT_CONDITION: "出力条件",
		PRINT_PREVIEW: "印刷プレビュー",

		MASSAGE_INJURY_NAME: "マッサージ傷病名",
		DISEASE_NAME: "鍼灸傷病名",
		DISEASE_NAME_OTHER: "鍼灸傷病名(その他)",
		MASSAGE_INJURY: "往療有無",
		COST_PER_TIME: "1回あたり(円)",
		TIME_PER_WEEK: "週の回数目安(回)",
		COST_PER_MONTH: "1ヶ月あたり(円)",
		WALKING_STATE: "歩行状態",
		WALKING_STATE_OTHER: "歩行状態(その他詳細)",
		FUTURE_TREATMENT_DETAILS: "今後の施術内容",
		GOAL: "目標・スケジュール",
		LONG_TERM_GOAL: "長期目標",
		SHORT_TERM_GOAL: "短期目標",
		STATE_BEFORE_TREATMENT: "施術前の状態",
		TREATMENT_DETAILS: "施術内容",
		MONDAY: "月曜日",
		TUESDAY: "火曜日",
		WEDNESDAY: "水曜日",
		THRUSDAY: "木曜日",
		FRIDAY: "金曜日",
		SATURDAY: "土曜日",
		SUNDAY: "日曜日",
		OTHER_SCHEDULE: "その他スケジュール",
		DOCTOR_IN_CHARGE: "担当医",
		CONSENT_HOLDER: "同意書取得者",
		NO_HOLIDAY_TREATMENT: "祝日施術なし",

		MUSCLE_PARALYSIS: '筋麻痺',
		MUSCLE_ATROPY: '筋萎縮',
		JOINT_CONTRACTURE: '関節拘縮',
		JOINT_CONTRACTURE_OTHER: '関節拘縮（その他）',
		SYMPTOMS: '症状',
		OTHER_SYMPTOMS: '症状（その他）',
		TREATMENT_AREA: '施術部位',
		MASSAGE: 'マッサージ',
		ACCUPUNTURE_ELECTRICITY: '鍼灸電気',
		ACCUPUNTURE: '鍼灸',
		RESIDANCE_TYPE: "居宅",
		FACILITY_TYPE: "施設",
		OTHER_TYPE: "その他",
		DEFORMITY_MANUAL_CORRECTION: "変形徒手矯正術",
		WARM_COMPRESS_METHOD: "温罨法",
		TRIALUSERREGISTRATION: "お試し利用者登録",
		TRIAL_USER_INFO: "利用者情報",
		CARE_MANAGER_INFO_2P: "施設職員情報",
		REGISTERED_DATE: "作成日時",
		OPTIMAL_ROUTE: "最適ルート",
		OVER_ALL_ROUTE: '全体マップ',
		SEARCH_FOR_ROUTE: "チェックした事業所の最適ルートを検索します。",
		START_DATE: "開始日",
		END_DATE: "終了日",
		AHAKI_NUMBER: "あはき番号が入力されていません。",
		HEADQUARTER_USER_DELETE_MESSAGE: "本社ユーザーは削除できません。",
		USER_NAME: "利用者名",
		SEX: "性別",
		TRIAL_DAY: "お試し日",
		TRIAL_IMPLEMENTATION: "体験実施",
		CONSENT: "同意書",
		FIRST_TREATMENT_DAY: "初療日",
		PLEASE_UPLOAD_FILE: "このファイルをアップロードしてください。",
		DETAIL: "詳細",
		TO: "～",
		ABOUT_KEYWORD: "キーワード検索について",
		KEYWORD_SEARCH_TARGET: "【キーワード検索の対象】",
		PRINT_CONTENT: "印刷内容",
		OUTPUT_CONTENT: "出力内容",
		MORE_THAN_FILE: "最大 {files} つの添付ファイルをアップロードできます。",
		FILE_SIZE_VALIDATION: "添付ファイル（画像）は10MB以下である必要があります。",
		PASSWORDLENGTH: "パスワードは8文字から30文字の間で入力してください。",
		ROLE_DELETE: "アクセス権限マスタは複数同時に削除できません。1レコードだけ選択して削除処理を実行してください。",
		SEND: "送信",
		YES: "はい",
		EMAILEMPTYERROR: "施設職員情報にメールアドレスが登録されていません。メールアドレスを登録して再度実行してください。",
		DELETE_MAIN_FRANCHISE_MSG: "基幹店に設定されている場合すでに基幹店に設定されたロールを削除する事はできません。" + "<br>" + "設定されている拠点のデータを変更してください。",
		DELETE_SUB_FRANCHISE_MSG: "この拠点は既に各データに設定されています。" + "<br>" + "下記の設定を変更してから、再度削除してください" + "<br>",
		OFFICE_INFO_MSG: " 事業所情報" + "<br>",
		USER_INFO_MSG: " ユーザー情報" + "<br>",
		CUSTOMER_INFO_MSG: " 利用者情報" + "<br>",
		PLEASE_ADD_FILE: "まずファイルを追加してから、再度インポートしてください。",
		PLEASE_ADD_CSV_FILE: "csvファイルを追加して再度インポートしてください。",
		FILEUPLOADFAILED: "ファイルをアップロード出来ません。",
		SELECTTIME: "時間を選択",
		SELECTDATE: "日付を選択",
		LOGINID_REGEX: "{attribute}は半角英数で入力してください。",
		FILE_UPLOAD_SUCCESS: 'ファイルが正常にインポートされました。',
		FILE_UPLOAD_VALIDATION1: 'アップロードファイルの',
		FILE_UPLOAD_VALIDATION2: '件データ検証に失敗しました。',
		FILE_UPLOAD_VALIDATION3: '新しくダウンロードしたファイルの問題を確認して、もう一度アップロードしてください。',
		FILE_UPLOAD_IMPORT_LIMIT: 'インポートの数を1010に制限してください。',
		FILE_UPLOAD_EXPORT_LIMIT: 'エクスポートの数を8000に制限してください。',
		UPLOADING: 'アップロード',
		LATITUDE: '緯度',
		LONGITUDE: '経度',
		IMPORT_ROW1: '新規のインポートをする時は下記の番号から使用してください。',
		IMPORT_ROW2: '＊下記より小さい番号を使用した場合に上書きになります。',
		IMPORT_ROW3: '次の基幹店のインポート番号: ',
		IMPORT_ROW4: '次の拠点のインポート番号: ',
		IMPORT_ROW4_1: '次の基幹店と拠点のインポート番号: ',
		IMPORT_ROW5: '次の事業所のインポート番号: ',
		PRACTITIONER_UPDATE_MSG: '現在のユーザーは 施術家です。更新したい場合は、施術家登録画面に更新してください。',
		DUPLICATE_SUB_FRANCHISE: '同じ拠点が選択されています。確認してください。',
		REMOVE_HONBU_ITEMS: '共通は省く',
		PRACTITIONER_LIST_USER_DELETE: "現在のユーザーは 施術家です。 削除したい場合は施術者マスター覧で削除してください。",
		BUSINESS_HISTORY_STATUS: "営業履歴ステータス",
		BUSINESS_HISTORY: "営業履歴",
		CAREMANAGER: "施設職員情報",
		CUSTOMER: "利用者情報",
		WRONG_BUILDING_NAME_MESSAGE_UPDATE: "正常に更新されました。<br><br><h6 style='color:#003267'>注意：建物を除く住所から経度緯度を計算しました。</h6>",
		WRONG_BUILDING_NAME_MESSAGE_CREATE: "正常に作成されました。<br><br><h6 style='color:#003267'>注意：建物を除く住所から経度緯度を計算しました。</h6>",
		NO_LAT_LNG_FOUND: "登録しようとした住所から、「経度、緯度」が取得出来ませんでした。<br><h5 style='color:#003267'>正しい住所を確認して、登録してください。</h5>",
		HOMELOGINMESSAGE: "ログインする拠点を選択してください",
		ADDRESSANDBUILDINGNAME: "都道府県+住所+建物名を1～65文字で入力してください。",
		LOGIN_TIMEOUT: "セッションタイムアウトになりました。再度ログインしてください。",
		FILE_COMPRESSED_ERROR: "添付ファイルが自動圧縮処理後も３Mを超えています。ファイルサイズを確認してください。",
		MULTIPLE_KEYWORD_NOT_ALLOWED: "※複数のキーワードは検索できません",
		USER: "利用者",
		PERSON_INCHARGE: "担当者",
		AHAKI_NUMBER_ERROR: "あはき番号は半角数値とハイフンのみ入力できます。",
		REMOVE_ATTACHMENT: "画像の削除は「添付資料に反映」で更新時に削除されます。",
		ATTACHMENT_FILE_FORMAT_ERROR: "Jpeg,Png,PDF以外は添付できません。",
		OTHER_FILE_FORMAT_ERROR: "Jpeg,Png以外は添付できません。",
		PDF_SIZE_ERROR: "添付ファイル（PDF）は5MB以下である必要があります。",
		ATTACHMENT_MESSAGE: "画像（Jpeg,Png)は10Mb以下　PDFは5Mb以下まで",
		MEDICALINSTADDRESSLENTGH: "市区町村の住所と建物名は 57 文字以内にしてください",
		// ATTACHMENT_MESSAGE: "画像（Jpeg,Png)は10Mb以下　PDFは5Mb以下まで",
		ATTACHMENT_MESSAGE: "画像（Jpeg,Png)は10Mb以下　PDFは5Mb以下で2ファイル迄",
		REMOVE_OTHER_ATTACHMENT: "画像の削除は「{type}」で更新時に削除されます。",
		FRANCHISE_BELOW_RANGE: "{attribute}は9以下で入力してください。",
		INSTITUTE_CODE: "医療機関コード",
		ADDRESSOVERWRITE: "すでに住所が入力されています。取得した郵便番号の住所で上書きしますか？",
		YES: "はい",
		NO: "いいえ",
		SAKSE_MAIN_FRANCHISE_NAME: "作成基幹店",
		SAKSE_SUB_FRANCHISE_NAME: "作成拠点",
		CONFIRMATION: "確認",
		SAKSE_MAIN_FRANCHISE_NAME_FILTER: "作成基幹店",
		SAKSE_SUB_FRANCHISE_NAME_FILTER: "作成拠点",
		SAKSE_MAIN_FRANCHISE_NAME: "作成基幹店略称",
		SAKSE_SUB_FRANCHISE_NAME: "作成拠点略称",
		HOJIN_INFORMATION: "法人マスタ",
		HOJIN_REGISTRATION: "法人マスタ登録",
		HOJIN_LIST: "法人マスタ一覧",
		ADD_SUBSCRIPTION: '追加',


		HOJIN_INFO: '法人情報',
		UMANAGED: '管理対象から外す',
		CORPORATE_CODE: '法人コード',
		CORPORATE_NAME: '法人名',
		CORORATE_NAME_ABVRIVATION: '法人名略称',
		CORPORATE_NAME_KANA: "法人名カナ",
		CORPORATE_SALES: '法人営業',
		DEPARTMENT: "部署名",
		CONTACT_NAME: '担当者名',
		CONTRACT_INFO: "契約情報",
		CONTRACT_TYPE: "契約タイプ",
		CONTRIBUTION_COLLECTION: "一部負担金徴収",
		BUSINESS_CONSIGMENT_FEE: "業務委託費％",
		CORPORATE_BUSINESS_FEE: '法人業務委託費',
		ADMINISTRATIVE_FEE: "事務手数料",
		TAX_RATE: "税率",
		CONTRACT_START_DATE: "契約開始日",
		CONTRACT_END_DATE: "契約終了日",
		INVOICE_ADDRESS_COMPANY: "請求書宛名社名",
		ADDRESS_TITLE: "宛名敬称",
		DATE_REGISTRATION: "登録日",
		SENDER_COMPANY: "送付元社名",
		SENDER_PHONE: '送付元電話番号',
		INVOICE_BUSINESS_NUMBER: "適格請求書事業者番号",
		SENDER_ZIP_CODE: "郵便番号",
		SENDER_PREFECTURE: "都道府県",
		SENDER_CITY: '市区町村・番地',
		SENDER_BUILDING: '建物名',
		ACC_INFO: "口座情報",
		BANK_NAME: '銀行名',
		BRANCH_NAME: "支店名",
		ACCOUNT_TYPE: "口座種別",
		ACCOUNT_NUMBER: "口座番号",
		ACCOUNT_HOLDER_NAME: "口座名義",
		REPORT_ADDRESS_COMPANY_NAME: '報告書宛名社名',
		CORPORATE_FAMILY_INFO: '法人施設情報',
		CORPORATE_FAMILY_REGISTRATION: "法人施設登録",
		PERSON_INCHARGE1: "担当者名1カナ",
		PERSON_INCHARGE2: "担当者名2カナ",
		CORPORATE_INVOICE_INFO: "法人請求情報",
		CORPORATE_INVOICE_REGISTRATION: '請求先登録',
		CORPORATE_INVOICE_REGISTRATION_LABEL: "法人請求情報登録",
		CORPORATE_BILLING_CODE: '法人請求コード',
		SHOW_INACTIVE_CORPORATE: "非アクティブ法人請求も表示",

		FACILITY_PERSONAL: '施設対応者',
		TRAVEL_COMPANION: "同行者",
		KEY_PERSON: "キーパーソン",
		LETTER_ENCLOSED: "手紙同封",
		LETTER_ENCLOSED2: "手紙同封",
		PROPOSEAL_TIMING: "提案タイミング",
		TIMING_DENTAL_VISIT: "訪問歯科提案タイミング",
		REASON_PROSPECT_ANGLE: "見込み角度理由",
		REASON_EXPECTED_ACCURACY: "見込み確度理由",
		RESPONSE_REPORT: "コメントー>対応報告",
		THANK_YOU_EMAIL: "お礼メール",
		THANK_YOU_PHONE_CALL: "お礼電話",
		COMMON_CANNOT_CHANGE: "共通は変更できません",
		PLEASE_UNSELECT_FLAG: "他の基幹店に割り当てる前に、[この拠点を基幹店に設定] のチェックを外してください。",
		SETTING: "設定",
		PERSON_INCHARGE_SETTING: "担当者設定",
		PERSON_INCHARGE_ERROR: "ユーザーが選択されていません。",
		FAVOURITE_SETTING: "お気に入り設定",
		SHOW_FAVOURITE_ONLY: "お気に入りのみ表示",
		SET_FAVOURITE: "お気に入りにする",
		FAVOURITE_DATA_ERROR: "お気に入り設定から追加または削除を選択してください。",
		CONFIRM_USER_REG_MANAGER: "本部送信ではなく本登録で宜しいですか？",
		SHOW_INACTIVE_BASE_ALSO: "非アクティブ拠点も表示",
		KANA_ONLY: "{attribute}は「カナ」のみ入力できます。",
		SAKSE_SUB_FRANCHISE_NAME: "作成拠点略称",
		CORPORATEFACILITYLIST: "法人施設一覧",
		FIRST_CONTRACT_DATE: "初回契約日",
		CORPORATE_FACILITY_REGISTRATION: "法人施設登録",
		CORPORATE_FACILITY_NAME: "法人施設名",
		CORPORATE_FACILITY_NAME2: "法人施設名2",
		CORPORATE_FACILITY_NAME_KANA: "法人施設名カナ",
		CORPORATE_FACILITY_CODE: "法人施設コード",
		CORPORATE_CODE: "法人コード",
		CORPORATE_NAME: "法人名",
		CORPORATE_TYPE: "事業所種別",
		NUMBER_OF_ROOMS: "居室数",
		NUMBER_OF_TRAILS: "お試し数(人)",
		NUMBER_OF_USERS: "本利用数(人)",
		EXISTING_SALES_PERSON: "既存営業担当",
		GO_BACK_CORPORATE_FACILITY_LIST: "法人施設一覧に戻る",
		CORPORATE_FACILITY_DETAILS: "法人施設情報",
		REMOVE_FROM_MANAGEMENT: "管理対象から外す",
		USER_RATE: "利用率",
		CORPORATE_AREA: "エリア",
		BILING_ADDRESS_CODE: " 法人請求コード",
		RESPONSIBLE_BASE_LIST: "担当拠点",
		RESPONSIBLE_BASE_REGISTRATION: "担当拠点登録",
		UNMANAGED_FACILITY_LIST: "管理対象外も表示する",
		GO_BACK_CORPORATE_FACILITY_DETAILS: "法人施設情報に戻る",
		RESPONSIBLE_BASE_ABBRIVIATION: "拠点名略称",
		FAVOURITE_SETTING: "お気に入り設定",
		SHOW_FAVOURITE_ONLY: "お気に入りのみ表示",
		SET_FAVOURITE: "お気に入りにする",
		FAVOURITE_DATA_ERROR: "お気に入り設定から追加または削除を選択してください。",
		CONFIRM_USER_REG_MANAGER: "本部送信ではなく本登録で宜しいですか？",
		TRAVEL_COMPANION: "同行者",
		FACILITY_RESPONSE_PERSON: "施設対応者",
		KEY_PERSON: "キーパーソン",
		THANK_YOU_EMAIL: "お礼メール",
		THANK_YOU_PHONE: "お礼電話",
		COMMENT_REPORT: "コメント→対応報告",
		ONLY_CORPORATE: "法人案件表示",
		ONLY_OFFICE: "一般案件表示",
		RESPONSIBLE_BASE_ABBRIVIATION: "拠点名略称",
		CORPORATE_FACILITY_CODE_ERROR: "{attribute}は6桁の数字のみ入力してください。",
		DECIMAL_VALIDATION_HOJIN: "半角数字を入力してください(小数が含まれている場合は、小数点以下第1位までの桁数に制限してください)",
		DUPLICATE_BASE_EXISTS: "選択した拠点は指定された施設にすでに登録されています。",
		CORPORATE_TYPE_REQUIRED: "事業所種別 が入力されていません。",
		INVALID_END_DATE: "終了日は開始日より後の日付である必要があります。",
		BILLING_CODE: "{attribute}は4桁の数字のみ入力してください。",
		ELIGIBLE_BILLING_OPERATOR_NUMBER: "{attribute}は13桁の数字のみ入力してください。",
		MAX7: "{attribute}は7桁の数字のみ入力してください。",
		TRIAL_REQUEST_NOTIFICATION: "お試し依頼通知",
		HOJIN: "法人案件",
		HOJIN_VALUE: "【法人】",
		CORPORATE_SEARCH: "法人施設検索",
		OFFICE_SEARCH: "一般施設検索",
		CONTACT_INFORMATION: "連絡先",
		REQUESTED_DATE: "依頼日",
		FAMILY_CONFIRMATION: "家族確認書",
		JOKYO: "状況",
		VENUE_ALLOCATION_DATE: "場割日",
		MAIL_RECEIPT: "レセプト郵送",
		PROXY: "代筆",
		CAREMAN_SEARCH: "施設職員検索",
		ADD_MORE_CONTACT: " 連絡先を追加",
		HOJIN_UNCHECK_ERROR: "選択されている法人施設が解除され、関連項目も変更されました。ご確認お願いします。",
		CORPORATE_HISTORY_CAUTION_MSG: "他店・本部スタッフの営業履歴は発生日時のみ表示しております。",
		CANCLE_TO_CORPORATE_CASE: "法人案件を解除しますがよろしいでしょうか？",
		//for hojin 注釈隣 HW-2
		CORPORATECHUITITLE: "一覧詳細について",
		UPDATEDATEDESCENDING: "更新日時降順",
		CONTRACTTYPELATESTSHOW: "契約タイプ：最新契約タイプを表示",
		OUTSOURCINGFEE: "法人業務委託費・事務手数料：税込み",
		MENUAL_LINK: "マニュアル",
		PLEASEIMPORTORDER: "以下の順序でインポートしてください。",
		HOJINIMPORT: "法人情報インポート",
		HOJINCONTRACTIMPORT: "契約情報インポート",
		HOJINBILLINGIMPORT: "法人請求情報インポート",
		EXPORT_FILTERED: "検索結果全件をエクスポート",
		FACILITY_IMPORT: "法人施設情報インポート",
		RESPONSIBLE_BASE_IMPORT: "担当拠点インポート ",

		ONLY_EMPTY: "未入力を検索",

	},
};
const i18n = new VueI18n({ locale: "ja", fallbackLocale: "en", messages });

export default i18n;
